import { css } from '@emotion/core';
import { colorsPalette, hexToRgba } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

const MOBILE_DISTANCE = 24;

export const containerMarginCss = css({
  margin: '48px 0',
  [MediaQueries.mdAndUp]: {
    margin: '64px 0',
  },
});

export const headlineCss = css(typography.effra40, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  marginBottom: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 24,
    width: '90%',
  },
});

export const overlayModal = {
  backgroundColor: hexToRgba(colorsPalette.black, 0.5),
};

export const contentModal = {
  bottom: 'auto',
  left: '50%',
  minHeight: '30%',
  minWidth: '30%',
  right: 'auto',
  top: '50%',
  transform: 'translate(-50%, -50%)',
};

export const modalWrapper = css({
  maxHeight: `calc(100vh - ${MOBILE_DISTANCE * 2}px)`,
  minHeight: '58vh',
  padding: '64px 24px 0',
  width: `calc(100vw - ${MOBILE_DISTANCE * 2}px)`,
  [MediaQueries.md]: {
    maxHeight: '55vh',
    maxWidth: 572,
    minHeight: '30vh',
    padding: '32px',
  },
  [MediaQueries.lgAndUp]: {
    maxHeight: 700,
    maxWidth: 622,
    minHeight: 400,
    padding: '80px 109px 30px',
  },
});

export const closeButton = css({
  right: MOBILE_DISTANCE,
  top: MOBILE_DISTANCE,
  [MediaQueries.mdAndUp]: {
    right: 32,
    top: 32,
  },
});

export const languagesWrapper = css({
  display: 'flex',
  flexWrap: 'wrap',
});

export const countryWrapper = css({
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: `${MOBILE_DISTANCE}px 0`,
  position: 'relative',
  textAlign: 'left',
  width: '100%',
  '&:after': {
    borderBottom: `1px solid ${colorsPalette.grey20}`,
    bottom: 0,
    content: "''",
    height: 1,
    left: 0,
    position: 'absolute',
    width: '100%',
  },
  [MediaQueries.md]: {
    padding: '32px 0 29px',
    width: '33.3%',
    '&:nth-child(3n-2)': {
      '&:after': {
        width: '300%',
      },
    },
  },
  [MediaQueries.lgAndUp]: {
    padding: '32px 0 29px',
    width: '50%',
    '&:nth-child(2n-1)': {
      '&:after': {
        width: '200%',
      },
    },
  },
});
